// import HmsManager, {
//     HMSUpdateListenerActions,
//     HMSConfig,
//   } from '@100mslive/react-native-hms';

import { APIs } from "../api/APIs";
import SafeairManager from "../api/SafeairManager";
class HmsVideocallManager {
  static async createRoom() {
    const apiConfig = {
      api: APIs.HmsVideocall.CreateRoom,
      parameters: null,
      body: null
    };
    const response = await SafeairManager.invoke(apiConfig);
    return response.data;
  }

  static async joinRoomConfig(username, roomId) {
    const apiConfigGenerateToken = {
      api: APIs.HmsVideocall.GenerateClientToken,
      body: {
        roomId,
        userId: username,
        role: "guest",
      },
      parameters: null,
    };
    const response = await SafeairManager.invoke(apiConfigGenerateToken);
    let authToken = response.data.token;
    return { authToken, userName: username };
  }
}

export default HmsVideocallManager;
